// extracted by mini-css-extract-plugin
module.exports = {"topVendorsArrows":"style_topVendorsArrows___mCdJ","topVendorsContainer":"style_topVendorsContainer__suthB"};